module.exports = __webpack_public_path__ + "media/images/athletes/3565-de57a801357b1a97ec0ad293b26597c4.png";